import { render, staticRenderFns } from "./paper-read.vue?vue&type=template&id=b62194f4&scoped=true"
import script from "./paper-read.vue?vue&type=script&lang=js"
export * from "./paper-read.vue?vue&type=script&lang=js"
import style0 from "./paper-read.vue?vue&type=style&index=0&id=b62194f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62194f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b62194f4')) {
      api.createRecord('b62194f4', component.options)
    } else {
      api.reload('b62194f4', component.options)
    }
    module.hot.accept("./paper-read.vue?vue&type=template&id=b62194f4&scoped=true", function () {
      api.rerender('b62194f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/paper-read.vue"
export default component.exports